module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/static-modal-app/img/shape-2@3x__0e68593a89dfa4172a3e1f6edee7b1fc.png";